import { Component, OnInit, Injector } from '@angular/core';
import { procedureI } from 'app/core/interfaces/procedure';
import { ProcedureService } from 'app/core/http/services/procedure.service';
import { BaseComponent } from 'app/modules/shared/components/base.component';
import { ScheduleRegistrationComponent } from '../registration/schedule-registration.component';

@Component({
  selector: 'page-schedule-procedure',
  templateUrl: './schedule-procedure.component.html',
  styleUrls: ['./schedule-procedure.component.scss'],
})
export class ScheduleProcedureComponent
  extends BaseComponent
  implements OnInit
{
  public title = 'Agendar exame';
  public search = '';
  public procedures: procedureI[] = [];

  public get proceduresFilter(): procedureI[] {
    const procedures = [...this.procedures];

    return procedures;
    /** 
    return procedures.filter((item: procedureI) =>     
    (this.search == '' ||
     (item.name && item.name.indexOf(this.search) > -1) ||       
     (item.organization.address &&  item.organization.address.city && item.organization.address.city.indexOf(this.search) > -1))    
    ); */
  }
  constructor(
    private procedureService: ProcedureService,
    private injector: Injector
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.getProcedures();
  }

  openComponentDialogScheduleRegistrationForm(procedure: any) {
    const data = {
      title: 'Agendar Exame',
      param: { procedure, type: 'Exame' },
    };

    this.dialog.openComponentDialog(ScheduleRegistrationComponent, data);
  }

  getProcedures() {
    //@TODO GET procedures
    this.procedureService.getProcedures().subscribe((result: any[]) => {
      this.procedures = result as procedureI[];
    });
    //temporario localstorage
    this.procedures = this.auth.getFromLocalStorage('procedures');
  }

  getCity(procedure: procedureI) {
    /** 
    if ( procedure.organization.address && (procedure.organization.address.city || procedure.organization.address.state)) {
      return `${procedure.organization.address.city}/${procedure.organization.address.state} `;
    }
    return '';*/
  }

  getHospitalName(procedure: procedureI) {
    if (procedure.organization) {
      return `<br>${procedure.organization.name}  `;
    }
    return '';
  }
}
